import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "news-keyword"
};
const _hoisted_2 = {
  key: 0,
  class: "content-block mt-3"
};
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center h-[233px] text-[#4E5969] col-span-full"
};
const _hoisted_4 = {
  key: 1,
  class: "empty-block"
};
const _hoisted_5 = {
  key: 2,
  class: "flex justify-between p-4 mt-2"
};
const _hoisted_6 = {
  class: "flex items-center gap-2"
};
const _hoisted_7 = {
  class: "text-ms text-[#4E5969]"
};
import { ElMessage } from 'element-plus';
import { Loading } from '@element-plus/icons-vue';
import { ref, computed, inject, toRaw, onMounted, onUnmounted } from 'vue';
import MenuBlock from '@components/MenuBlock.vue';
import FlowingLight from '@components/special-effects/FlowingLight.vue';
import useMainStore, { storeToRefs } from '@views/main/main.store';
import initIncrementalUpdate from '@views/main/components/report-items/mixins/incrementalUpdate.mixin';
import { pubWorkflow, updateArticleContent } from '../../api';
import NewsCard from './components/NewsCard.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'NewsKeyWord',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const defaultData = () => {
      return {
        articleDetails: [],
        genTotalCount: 0,
        keywordCount: 1,
        newsCount: 0,
        done: false,
        tips: ''
      };
    };
    const mainStore = useMainStore();
    const {
      messageContentMap,
      incrementalMessageList
    } = storeToRefs(mainStore);
    const messageContent = ref([]);
    const tabIns = ref(0);
    const info = ref(defaultData());
    const btnLoading = ref(false);
    const tabList = computed(() => {
      const arr = [];
      if (info.value.articleDetails) {
        info.value.articleDetails.forEach((item, index) => {
          arr.push({
            label: item.knowledgeDetailBo?.keyword || '--',
            value: index
          });
        });
      }
      return arr;
    });
    const checkFiles = computed(() => {
      const ret = [];
      info.value.articleDetails.forEach(item => {
        item.articleFileIds.forEach(file => {
          if (file.checked) {
            ret.push(file);
          }
        });
      });
      return ret;
    });
    const totalArticleFile = computed(() => {
      const ret = [];
      info.value.articleDetails.forEach(item => {
        item.articleFileIds.forEach(file => {
          ret.push(file);
        });
      });
      return ret;
    });
    const handleCheck = item => {
      item.checked = !item.checked;
    };
    const openSideEdit = inject('openSideEdit');
    const handleToggleFull = item => {
      const obj = info.value.articleDetails[tabIns.value];
      let sonIns = obj.articleFileIds.findIndex(son => son.id === item.id) || 0;
      sonIns = sonIns < 0 ? 0 : sonIns;
      openSideEdit({
        type: 'edit_news',
        typeQuery: {
          active: tabIns.value,
          sonIns
        },
        contentData: toRaw(info.value),
        title: '编辑内容',
        callBack: (data, item) => {
          info.value.articleDetails.forEach(i => {
            i.articleFileIds.forEach(file => {
              if (file.id === item.id) {
                file.animationText = item.animationText;
                file.text = item.text;
                file.fileName = item.fileName;
                file.fileTitle = item.fileTitle;
              }
            });
          });
          updateArticleContent({
            fileId: item.id,
            fileContent: item.text,
            fileTitle: item.fileName
          }).then(() => {
            ElMessage.success('保存成功');
          });
        }
      });
    };
    const handlePublish = async () => {
      const articleDetails = [];
      info.value.articleDetails.forEach(k => {
        const checkedList = k.articleFileIds.filter(item => item.checked);
        if (checkedList.length) {
          articleDetails.push({
            articleFileIds: checkedList.map(f => ({
              id: f.id,
              fileTitle: f.fileTitle
            })),
            knowledgeDetailBo: {
              keyword: k.knowledgeDetailBo.keyword,
              keywordId: k.knowledgeDetailBo.keywordId,
              attachmentDetails: k.knowledgeDetailBo.attachmentDetails.map(f => ({
                fileId: f.fileId,
                knowledgeId: f.knowledgeId
              }))
            }
          });
        }
      });
      const params = {
        optType: 'SELECT_ARTICLE_PUB',
        sessionId: mainStore.msgParams.sessionId,
        sourceId: props.item.id,
        articleDetails
      };
      try {
        btnLoading.value = true;
        await pubWorkflow(params);
        ElMessage.success('提交成功');
      } catch (error) {
        console.error('API调用失败:', error);
      } finally {
        btnLoading.value = false;
      }
    };
    const {
      handleIncrementalMessage
    } = initIncrementalUpdate(async message => {
      const {
        incrementalData
      } = message;
      info.value.done = incrementalData.done;
      let knowledgeItem = info.value.articleDetails.find(item => item.knowledgeDetailBo.keywordId === incrementalData.knowledgeDetailBo.keywordId);
      if (!knowledgeItem) {
        knowledgeItem = incrementalData;
        knowledgeItem.articleFileIds = [];
        info.value.articleDetails.push(knowledgeItem);
      }
      if (incrementalData.success) {
        const file = incrementalData.content;
        file.fileName = file.fileTitle;
        file.animationText = file.fileContent;
        file.text = file.animationText;
        knowledgeItem.articleFileIds.push(file);
      }
      if (incrementalData.done) {
        mainStore.loadNextMsg(props.item);
      }
    });
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
    });
    onMounted(() => {
      console.log('props', props, messageContentMap);
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
      }
      try {
        let doneCount = 0;
        if (props.content) {
          info.value = props.content;
          info.value.newsCount = info.value.genTotalCount / info.value.keywordCount;
          messageContent.value = messageContentMap.value[props.item.id] || [];
          if (!info.value.articleDetails) {
            info.value.articleDetails = [];
          }
          info.value.articleDetails.forEach(item => {
            if (!item.articleFileIds) {
              item.articleFileIds = [];
            }
            item.articleFileIds.forEach(file => {
              doneCount++;
              const attach = messageContent.value.find(son => son.id === file.id);
              file.fileName = file.fileTitle;
              file.animationText = attach ? attach.strFileContent : '';
              file.text = file.animationText;
            });
          });
        }
        // 处理增量数据
        if (props.item.incrementalIds) {
          props.item.incrementalIds.forEach(id => {
            handleIncrementalMessage(incrementalMessageList.value[id]);
          });
        }
        if (info.value.genTotalCount > 0 && doneCount === info.value.genTotalCount) {
          info.value.done = true;
        }
        mainStore.loadNextMsg(props.item);
      } catch (error) {
        debugger;
        info.value = defaultData();
        console.log(error);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(MenuBlock, {
        list: tabList.value,
        modelValue: tabIns.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tabIns.value = $event)
      }, null, 8, ["list", "modelValue"]), info.value.articleDetails[tabIns.value] ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.articleDetails[tabIns.value].articleFileIds, item => {
        return _openBlock(), _createBlock(NewsCard, {
          key: item.keyword,
          title: item.fileName,
          isMd: "",
          content: item.animationText || item.text,
          checked: item.checked,
          "onUpdate:checked": $event => handleCheck(item),
          onToggleFull: $event => handleToggleFull(item)
        }, null, 8, ["title", "content", "checked", "onUpdate:checked", "onToggleFull"]);
      }), 128)), info.value.articleDetails[tabIns.value].articleFileIds.length < info.value.newsCount && !info.value.done ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(info.value.newsCount - info.value.articleDetails[tabIns.value].articleFileIds.length, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item,
          class: "w-full h-[233px] flex justify-center items-center rounded-[6px] overflow-hidden"
        }, [_createVNode(FlowingLight, null, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
            class: "loader"
          }, null, -1), _createElementVNode("div", {
            class: "text-xs text-[#4E5969] mt-1"
          }, "内容生成中……", -1)]))]),
          _: 1
        })]);
      }), 128)) : _createCommentVNode("", true), info.value.done && !info.value.articleDetails[tabIns.value].articleFileIds.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 文章生成失败 ")) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
        class: "loading-block"
      }, [_createElementVNode("div", {
        class: "loader"
      }), _createElementVNode("div", {
        class: "text-xs text-[#4E5969] mt-1"
      }, "AI正在对内容生成中……")], -1)]))])), info.value.articleDetails[tabIns.value] ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", null, _toDisplayString(info.value.done ? `本次任务消耗${totalArticleFile.value.length * 1}点` : " "), 1), _createElementVNode("div", _hoisted_6, [!info.value.done ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_icon, {
        class: "is-loading"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Loading))]),
        _: 1
      }), _createElementVNode("div", _hoisted_7, " 内容生成中( " + _toDisplayString(totalArticleFile.value.length) + " / " + _toDisplayString(info.value.genTotalCount) + " ) ", 1)], 64)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        type: "primary",
        disabled: !checkFiles.value.length || !info.value.done,
        loading: btnLoading.value,
        onClick: handlePublish
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" 发布内容 ", -1)]))]),
        _: 1
      }, 8, ["disabled", "loading"])])])) : _createCommentVNode("", true)]);
    };
  }
});